import { Survey } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    items: [],
    item: {},
    totalCount: 0,
    loading: false,
    query: {},
    questions: []
  },
  actions: {
    async fetch({ commit }, params) {
      const items = await Survey.fetch(params)
      commit('changeState', { items })
    },
    async fetchOne({ commit }, id) {
      const item = await Survey.fetchOne(id)
      const questions = item.questions
      commit('changeState', { item })
      commit('changeState', { questions })
    },
    async count({ commit }, params) {
      const totalCount = await Survey.count(params)
      commit('changeState', { totalCount })
    },
    async create({ commit }, data) {
      const item = await Survey.create(data)
      return item
    },
    async update({ commit }, { id, ...data }) {
      await Survey.update(id, data)
    },
    async remove({ commit }, id) {
      await Survey.remove(id)
    }
  },
  mutations: {
    setState(state, { atr, value }) {
      state[atr] = value
    }
  },
  getters: {
    item: state => state.item
  }
}
